import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageRoleService } from 'src/app/components/user-management/services/manage-role.service';
import { SnackbarService } from 'src/app/_service/message-service';

export interface rolesData {
	name: string;
	description: string;
}

export interface JsonFormData {
	controls: JsonFormControls[];
}

interface JsonFormControls {
	name: string;
	label: string;
	value: any;
	type: string;
	validators: JsonFormValidators;
	options?: JsonFormControlOptions;
	error?: string;
	placeholder: string;
	disabled?: boolean;
}

interface JsonFormValidators {
	required?: boolean;
	minLength?: number;
	pattern?: string | RegExp;
	maxLength?: number;
}

interface JsonFormControlOptions {
	min?: string;
	max?: string;
	step?: string;
	icon?: string;
	width?: string;
	height?: string
}

@Component({
	selector: 'telio-dynamic-form',
	templateUrl: './dynamic-form.component.html',
	styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit, OnDestroy, OnChanges {
	isEdit = false;
	name = 'rbac.roles.name';
	description = 'rbac.roles.description';
	@Input() formList: JsonFormData;
	@Input() disabled = true;

	public options: UntypedFormGroup = this.fb.group({});

	constructor(public translate: TranslateService, public dialog: MatDialog, private fb: UntypedFormBuilder, readonly roleservice: ManageRoleService, private toastr: SnackbarService,
		readonly router: Router, private route: ActivatedRoute) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes['formList'].firstChange) {
			this.createForm(this.formList.controls);
		}
	}

	createForm(controls: JsonFormControls[]) {
		for (const control of controls) {
			const validatorsToAdd = [];
			for (const [key, value] of Object.entries(control.validators)) {
				switch (key) {
					case 'min':
						validatorsToAdd.push(Validators.min(value));
						break;
					case 'max':
						validatorsToAdd.push(Validators.max(value));
						break;
					case 'required':
						if (value) {
							validatorsToAdd.push(Validators.required);
						}
						break;
					case 'requiredTrue':
						if (value) {
							validatorsToAdd.push(Validators.requiredTrue);
						}
						break;
					case 'email':
						if (value) {
							validatorsToAdd.push(Validators.email);
						}
						break;
					case 'minLength':
						validatorsToAdd.push(Validators.minLength(value));
						break;
					case 'maxLength':
						validatorsToAdd.push(Validators.maxLength(value));
						break;
					case 'pattern':
						validatorsToAdd.push(Validators.pattern(typeof value === 'string' ? value : value.toString()));
						break;
					case 'nullValidator':
						if (value) {
							validatorsToAdd.push(Validators.nullValidator);
						}
						break;
					default:
						break;
				}
			}
			const controlDisabled = control.disabled ? { disabled: true } : { disabled: false };
			this.options.addControl(
				control.name,
				this.fb.control({ value: control.value, ...controlDisabled }, validatorsToAdd)
			);
		}
	}

	ngOnInit(): void {
		this.createForm(this.formList.controls);
	}

	getErrorMessage(field: any, error: string) {
		if (this.options.get(field).hasError('required')) {
			return this.options.get(field).hasError('required') ? this.translate.instant('requiredError') : error;
		}

		else if (this.options.get(field).hasError('pattern'))
			return this.options.get(field).hasError('pattern') ? this.translate.instant('invalidPattern') : error
	}

	ngOnDestroy(): void { }
}


